<template>
  <section class="ppt-help">
    <header class="page-header">
      <h1>Help</h1>
    </header>
    <p>Specific tools:</p>
    <ul>
      <li><router-link to="/help/equity-calculator">Equity calculator</router-link></li>
      <li><router-link to="/help/hit-calculator">Hit calculator</router-link></li>
      <li><router-link to="/help/equity-matrix">Equity matrix</router-link></li>
      <li><router-link to="/help/range-constructor">Range constructor</router-link></li>
      <li><router-link to="/help/should-you-bluff">Should you bluff?</router-link></li>
      <li><router-link to="/help/should-you-call">Should you call?</router-link></li>
      <li><router-link to="/help/breakeven-percentage-for-bluffing-the-turn">Breakeven percentage for bluffing the turn</router-link></li>
      <li><router-link to="/help/three-bet-cbet-explorer">3bet-cbet explorer</router-link></li>
    </ul>
    <p>Other:</p>
    <ul>
      <li><router-link to="/faq">FAQ</router-link></li>
      <li><router-link to="/quick-guide">Quick guide</router-link></li>
      <li><router-link to="/beginners-guide">Beginners guide (old)</router-link></li>
      <li><router-link to="/made-hands-and-draws">Made hands and draws</router-link></li>
    </ul>
  </section>
</template>

<script>
export default {
  name: 'ppt-help',
};
</script>

<style lang="scss" scoped>
  .ppt-help {
    font-size: 18px;

    @media (max-device-width: 768px) {
      li {
        margin-bottom: 15px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/help/help.vue